ACC.autocomplete = {

    bindAll: function()
    {
        this.bindSearchAutocompleteFredhopper();
    },

    bindSearchAutocompleteFredhopper: function()
    {
        var noOfRequests = 0;
        var requestNo = 0;
        var cancelCloseSuggestions = false;
        var refocusSearchInput = true;
        var searchInput;
        var globalConfig;
        var currencyCode;

        // temporary until responsive and uses same input field, and config in
        // same place
        searchInput = document.getElementById( "in_site_search" );
        globalConfig = window.ACC;
        currencyCode = window.ACC.localCurrencyCode.toLowerCase();

        var limitRelatedTerms = function (relatedTerms) {
            var maxRelatedTerms = 10;
            if (Array.isArray(relatedTerms) && relatedTerms.length > maxRelatedTerms) {
                relatedTerms = relatedTerms.slice(0, maxRelatedTerms);
            }
            return relatedTerms;
        };

        var limitCategories = function (categories, relatedTerms) {
            if (Array.isArray(categories)) {
                var maxCategories = 7;
                var maxTermsAndCategoriesToShow = 11;

                if (categories.length > maxCategories) {
                    categories = categories.slice(0, maxCategories);
                }

                relatedTerms = limitRelatedTerms(relatedTerms);
                var countRelatedTerms = (Array.isArray(relatedTerms)) ? relatedTerms.length : 0;
                var totalItems = categories.length + countRelatedTerms;

                if (totalItems > maxTermsAndCategoriesToShow) {
                    var categoriesToRemove = totalItems - maxTermsAndCategoriesToShow;
                    categories = categories.slice(0, categories.length - categoriesToRemove);
                }
            }
            return categories;
        };

        var limitFeaturedProducts = function (featuredProducts) {
            var maxProducts = 4;
            if (Array.isArray(featuredProducts) && featuredProducts.length > maxProducts) {
                featuredProducts = featuredProducts.slice(0, maxProducts);
            }
            return featuredProducts;
        };

        /**
         * Create HTML for search suggest overlay utilising the response from Fredhopper
         * @param  {String} searchTerm       The term that was searched for by user
         * @param  {Array}  relatedTerms     List of objects containing details of related terms
         * @param  {Array}  categories       List of objects containing details of categories
         * @param  {Array}  featuredProducts List of objects containing details of products
         * @return {String}                  HTML to be appended to the DOM
         */
        var createSuggestionsHTML = function (searchTerm, relatedTerms, categories, featuredProducts) {
            return [
                '<section id="global_search_suggest" class="global_search_suggest' + (Array.isArray(featuredProducts) && featuredProducts.length > 0 ? '' : ' no-products') + '">',
                '<div>', // div around related terms and categories
                [
                    '<h2 class="global_search_suggest_title">',
                    '<span class="visually-hidden">Search </span>',
                    'Suggestions for &lsquo;<strong>' + searchTerm + '</strong>&rsquo;',
                    '</h2>'
                ].join(''),
                Array.isArray(relatedTerms) && relatedTerms.length > 0 ? [
                        '<section class="related_terms">',
                        '<h3>Related terms</h3>',
                        '<ul>',
                        relatedTerms.map(function(relatedTerm) {
                            // accentuate the search term in the category text ($& replaces match)
                            var processedTerm = relatedTerm.searchterm.replace(
                                new RegExp(searchTerm, 'gi'),
                                '<strong>$&</strong>'
                            );
                            return [
                                '<li>',
                                '<a href="">', // href allows to be 'tabbed' to for accessibility
                                processedTerm + ' <span>&#40;' + relatedTerm.nrResults + '&#41;</span>',
                                '</a>',
                                '</li>'
                            ].join('');
                        }).join(''),
                        '</ul>',
                        '</section>'].join('')
                    :
                    '',
                Array.isArray(categories) && categories.length > 0 ? [
                        '<section class="suggested_categories visually-hidden">',
                        '<h3>Categories</h3>',
                        '<ul>',
                        categories.map(function(category) {

                            // remove parent categories on the front end e.g. before and
                            // inc. ' > ' in 'Nightwear > Robes and Dressing Gowns'
                            var processedCategory = category.mlValue.match(/ \> ([^\>]+)$/, '');
                            processedCategory = (processedCategory !== null) ? processedCategory[1] : category.mlValue;

                            // accentuate the search term in the category text ($& replaces match)
                            processedCategory = processedCategory.replace(
                                new RegExp(searchTerm, 'gi'),
                                '<strong>$&</strong>'
                            );
                            return [
                                '<li>',
                                '<a href="#" data-catid="' + category.catid + '">',
                                processedCategory + '&nbsp;<span>&#40;' + category.nrResults + '&#41;</span>',
                                '</a>',
                                '</li>'
                            ].join('');
                        }).join(''),
                        '</ul>',
                        '</section>'].join('')
                    :
                    '',
                '</div>', // div around related terms and categories
                Array.isArray(featuredProducts) && featuredProducts.length > 0 ? [
                        '<section class="suggested_products">',
                        '<h3>Featured products for <span><strong>&lsquo;' + searchTerm + '&rsquo;</strong></h3>',
                        '<ul>',
                        featuredProducts.map(function(featuredProduct) {
                            var searchSuggestProperty = 'p_price_text_search_suggest' + '_' + currencyCode;
                            if(!featuredProduct.hasOwnProperty(searchSuggestProperty)) {
                                searchSuggestProperty = 'p_price_text_search_suggest';
                            }

                            var urlProperty = 'p_url';
                            if (featuredProduct.hasOwnProperty('p_searchresult_url')) {
                                urlProperty = 'p_searchresult_url';
                            }
                            return [
                                '<li>',
                                '<a href="'+ ACC.config.requestContextPath + featuredProduct[urlProperty] + '">',
                                '<img class="featured_product_image" src="' + featuredProduct["p_img_search_suggest"] + '" alt="" height="81" width="80" />',
                                '<dl>',
                                '<dt>Product description</dt>',
                                '<dd>' + (featuredProduct.p_name.length > 59 ? featuredProduct.p_name.substring(0, 59) + '&hellip;' : featuredProduct.p_name) + '</dd>',
                                '<dt>Product price</dt>',
                                '<dd>' + featuredProduct[searchSuggestProperty] + '</dd>',
                                (
                                    featuredProduct.hasOwnProperty('p_review_avg_img_url')
                                    && featuredProduct.hasOwnProperty('p_review_average_rating')
                                    && featuredProduct.hasOwnProperty('p_review_count')
                                    && featuredProduct['p_review_count'] > 0
                                ) ? [
                                    '<dt>Average star rating</dt>',
                                    '<dd class="star_rating">',
                                    '<img ',
                                    'src="' + featuredProduct.p_review_avg_img_url + '" ',
                                    'alt="' + featuredProduct.p_review_average_rating + ' stars out of 5 average rating" ',
                                    '/>',
                                    '</dd>',
                                    '<dt>Number of reviews</dt>',
                                    '<dd class="review_count">&#40;' + featuredProduct.p_review_count + ' reviews&#41;</dd>'
                                ].join('') : '',
                                '</dl>',
                                '</a>',
                                '</li>'
                            ].join('');
                        }).join(''),
                        '</ul>',
                        '</section>'].join('')
                    :
                    '',
                '<a class="see-all-results" href="">See all results<span class="visually-hidden"> for search term &lsquo;<strong>' + searchTerm + '</strong>&rsquo;</span></a>',
                '</section>'
            ].join('');
        };

        /**
         * Validates search suggest input for not containing special characters
         * @param searchTerm input string to validate
         */
        var validateSearchSuggestInput = function(searchTerm) {
            if (searchTerm && globalConfig.searchSuggestSpecialCharacterValidationPattern.test(searchTerm)) {
                showSearchSuggestValidationMsg();
                return false;
            }
            hideSearchSuggestValidationMsg();
            return true;
        };

        /**
         * Shows search suggest validation message (if special characters are present in the input)
         */
        var showSearchSuggestValidationMsg = function() {
            $('.header__search').children('.js-errMessage').show();
        };

        /**
         * Hides search suggest validation message
         */
        var hideSearchSuggestValidationMsg = function() {
            $('.header__search').children('.js-errMessage').hide();
        };


        /**
         * Remove an existing search suggest overlay from the DOM
         * @return {void}
         */
        var removeExistingSearchSuggest = function(cancellable) {

            // this is cancellable if the search suggestions overlay is clicked
            if (cancellable && cancelCloseSuggestions) {

                // reset cancel state
                cancelCloseSuggestions = false;

                // focus the search input again so blur event captured correctly
                if (refocusSearchInput) {
                    searchInput.focus();

                    // or if we requested not to focus the input (as user is
                    // navigating search suggest with keyboard) reset this value
                } else {
                    refocusSearchInput = true;
                }

                // don't remove search suggestions
                return false;

                // remove search suggestions overlay
            } else {
                var existingSearchSuggest = document.getElementById('global_search_suggest');
                if (existingSearchSuggest) existingSearchSuggest.parentNode.removeChild(existingSearchSuggest);
            }
        };

        /**
         * Interrogate search term entered by user and search for suggestions
         * or handle as required
         * @param  {Object} event Details of the event triggering the function
         * @return {void}
         */
        var searchForSuggestions = function(event) {

            var searchTerm = event.target.value;

            // Remove the existing search suggestions if criteria not met. If
            // criteria met, perform request and show search suggestions to user
            switch (true) {

                case (searchTerm.length < globalConfig.autocompleteMinChars):
                case (event.type !== 'keyup'):
                case (event.keyCode === 13): // enter
                    removeExistingSearchSuggest();
                    validateSearchSuggestInput(searchTerm);
                    break;

                case (event.keyCode === 9):  // tab
                    // want the search suggest to be navigatable with keyboard
                    // so cancel closing of the search suggest and allow default
                    // behaviour of 'tab' (and 'Shift' + 'tab') key to navigate
                    break;

                case (event.keyCode === 27): // esc
                    // close the search suggest
                    cancelCloseSuggestions = false;
                    removeExistingSearchSuggest();
                    break;

                case (event.keyCode === 16): // shift
                case (event.keyCode === 17): // ctrl
                case (event.keyCode === 18): // alt
                case (event.keyCode === 20): // CAPS lock
                case (event.keyCode === 35): // end
                case (event.keyCode === 36): // home
                case (event.keyCode === 37): // left arrow
                case (event.keyCode === 38): // up arrow
                case (event.keyCode === 39): // right arrow
                case (event.keyCode === 40): // down arrow
                case (event.keyCode === 91): // left window (windows) / left cmd (mac)
                case (event.keyCode === 92): // right window (windows)
                case (event.keyCode === 93): // 'select' (windows) / right cmd (mac)
                    // Explicitly do nothing in terms of search suggestions.
                    // Leave results in DOM (don't remove) and don't do another
                    // search as the term is still the same
                    break;

                default:
                    if (!validateSearchSuggestInput(searchTerm)) {
                        removeExistingSearchSuggest();
                        return;
                    }
                    noOfRequests++;
                    $.ajax({
                        method: 'GET',
                        url: globalConfig.autocompleteUrl + encodeURIComponent(searchTerm.replace(/( &)/, '')), //remove '&' as agreed with FH (FHI-144)
                        dataType: 'jsonp',
                        success: function(response) {

                            // if the response is only from the latest request
                            // (this is to prevent incorrect updates to the DOM)
                            if (noOfRequests === ++requestNo) {

                                // clear DOM of existing suggestions
                                removeExistingSearchSuggest();

                                // define Fredhopper keys
                                var suggestions = {
                                    relatedTerms: '1keywords',
                                    categories: '2categories',
                                    products: '3products'
                                };

                                // expose data in response
                                for (var indexName in suggestions) {

                                    // search in response for suggestion group based on above keys
                                    var groupDetails = response.suggestionGroups.filter(function(index) {
                                        return index.indexName === suggestions[indexName];
                                    });

                                    // check the group for data
                                    suggestions[indexName] = (
                                        groupDetails.length
                                        && typeof groupDetails[0].suggestions !== 'undefined'
                                        && groupDetails[0].suggestions.length
                                    ) ?
                                        groupDetails[0].suggestions
                                        :
                                        undefined;
                                }

                                var relatedTerms = limitRelatedTerms(suggestions.relatedTerms);
                                var categories = limitCategories(suggestions.categories, suggestions.relatedTerms);
                                var featuredProducts = limitFeaturedProducts(suggestions.products);

                                // if there is data for any of the three sections to show
                                // in the search suggest overlay, render it
                                if (
                                    (Array.isArray(relatedTerms) && relatedTerms.length > 0)
                                    || (Array.isArray(categories) && categories.length > 0)
                                    || (Array.isArray(featuredProducts) && featuredProducts.length > 0)
                                ) {
                                    searchInput.insertAdjacentHTML(
                                        'afterend',
                                        createSuggestionsHTML(
                                            searchTerm,
                                            relatedTerms,
                                            categories,
                                            featuredProducts
                                        )
                                    );

                                    // get the newly appended HTML and find related terms
                                    var searchSuggest = document.getElementById('global_search_suggest');
                                    var relatedTermsLinks = searchSuggest.querySelectorAll('.related_terms a');
                                    var categoriesSection = searchSuggest.querySelector('.suggested_categories');
                                    var categoriesLinks = categoriesSection ? categoriesSection.querySelectorAll('a') : null;
                                    var allSearchSuggestLinks = searchSuggest ? searchSuggest.querySelectorAll('a') : null;
                                    var searchButton = document.getElementById('in_site_search_button');

                                    // bind click event to mock existing functionality
                                    // whereby search term is entered into search form
                                    // and form then submitted with new term
                                    if (relatedTermsLinks) Array.prototype.forEach.call(relatedTermsLinks, function(termLink) {
                                        termLink.addEventListener('click', function(event) {

                                            event.preventDefault();

                                            // get the term and remove the product count
                                            var relatedTermText = event.target.tagName === 'A' ? event.target.innerText : event.target.parentNode.innerText;
                                            searchInput.value = relatedTermText.replace(/\ \([0-9]+\)$/, '');

                                            // close the search suggestions overlay to
                                            // emphasise user interaction/input
                                            removeExistingSearchSuggest();

                                            // adding a negligible timeout which allows
                                            // the input value to be updated so the search
                                            // is performed correctly, and the term shows
                                            // visibly to the user whilst page transitions
                                            setTimeout(function() {
                                                // search button handles validation
                                                if (searchButton) {
                                                    searchButton.click();
                                                } else {
                                                    searchInput.form.submit();
                                                }
                                            }, 20);
                                        });
                                    });

                                    // submit the form as-is when 'see all' link clicked
                                    $('.see-all-results').on('click', function (event) {
                                        event.preventDefault();
                                        removeExistingSearchSuggest();
                                        // search button handles validation
                                        if (searchButton) {
                                            searchButton.click();
                                        } else {
                                            searchInput.form.submit();
                                        }
                                    });

                                    // bind click event to cancel removing search
                                    // suggestions from the DOM when in fact the search
                                    // input is unfocused in place of the suggestions
                                    searchSuggest.addEventListener('click', function() {
                                        cancelCloseSuggestions = true;
                                    });

                                    // bind focus event to cancel removing search
                                    // suggestions from the DOM when a user navigates
                                    // to content using keyboard with tab key
                                    if (allSearchSuggestLinks) Array.prototype.forEach.call(relatedTermsLinks, function(link) {
                                        link.addEventListener('focus', function() {
                                            cancelCloseSuggestions = true;
                                            refocusSearchInput = false;
                                        });
                                    });

                                    if (categoriesLinks) {

                                        // fetch the category ids from all of the category links
                                        // in the search suggestions. Fredhopper can't supply
                                        // site endpoints, so we need to perform another AJAX
                                        // request to Hybris to fetch these endpoints based on
                                        // the category ids returned by Fredhopper
                                        var categoryIds = [];
                                        var noOfCategoryLinks = categoriesLinks.length;
                                        for (var i = 0; i < noOfCategoryLinks; i++) {
                                            categoryIds.push(categoriesLinks[i].getAttribute('data-catid'));
                                        }

                                        // fetch category endpoints from Hybris
                                        if (categoryIds.length) $.ajax({
                                            method: 'GET',
                                            url: ACC.config.requestContextPath + '/json/getCategoryUrlsFromCatIds.json?ids=' + categoryIds,
                                            dataType: 'json',
                                            success: function(response) {

                                                // loop through the category links and try to match
                                                // details in the response to try to supply url to DOM
                                                Array.prototype.forEach.call(categoriesLinks, function(categoryLink) {

                                                    var matchingLinkObj = response.filter(function(linkObj) {
                                                        return linkObj.catid === categoryLink.getAttribute('data-catid');
                                                    });

                                                    // if there is a match, bind the url so the link works as expected
                                                    if (matchingLinkObj.length > 0) {
                                                        categoryLink.setAttribute('href', matchingLinkObj[0].href);
                                                        $(categoriesSection).removeClass('visually-hidden');

                                                        // if there is no match, the category link is removed
                                                        // as it serves no purpose and would otherwise do nothing
                                                    } else {
                                                        categoryLink.parentNode.removeChild(categoryLink);
                                                    }
                                                });
                                            },
                                            error: function() {

                                                // if there is an error with the request, we want to remove
                                                // all category links as they will not be functioning
                                                categoriesSection.parentNode.removeChild(categoriesSection);
                                            }
                                        });
                                    }
                                }
                            }
                        },
                        error: function() {
                            requestNo++;
                        }
                    });
                    break;
            }
        };

        // bind events to the search input field
        searchInput.addEventListener('blur', function() {
            setTimeout(function() {
                removeExistingSearchSuggest(true);
            }, 150);
        });
        searchInput.addEventListener('keyup', searchForSuggestions);
        document.body.addEventListener('keyup', function(event) {
            if (event.keyCode === 27) { // esc
                // close the search suggest
                cancelCloseSuggestions = false;
                removeExistingSearchSuggest();
            }
        });
    }
};

$(document).ready(function() {
    ACC.autocomplete.bindAll();
});
